import { Group, Paper, Text } from '@mantine/core';
import { formatCurrency } from '../../helpers/atAGlance';
import ChangeIndicator from './ChangeIndicator';

/**
 * One figure, its optional hint, and its movement against the previous period.
 *
 * Deliberately not SummaryCard: that one hides any metric whose current and
 * previous values are both zero, which on a quiet domain empties the whole card.
 * A measured zero is a fact worth showing.
 *
 * Omit `currency` for a count — the figure is then formatted as a plain localized
 * number, which is what a click or conversion count wants.
 *
 * @param {object} props
 * @param {string} props.label
 * @param {React.ReactNode} [props.icon]
 * @param {number} [props.value]
 * @param {number} [props.previousValue]
 * @param {string} [props.currency] - ISO code; omit to render `value` as a count
 * @param {string} [props.hint] - a second line under the figure
 * @param {boolean} [props.big] - for a headline figure rather than a breakdown
 * @param {React.ReactNode} [props.footer] - rendered last, e.g. a link to the figure's breakdown
 */
const MetricTile = ({ label, icon, value, previousValue, currency, hint, big, footer }) => (
  <Paper withBorder radius="md" p="md" role="group" aria-label={label}>
    <Group gap={6} wrap="nowrap">
      {icon}
      <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
        {label}
      </Text>
    </Group>
    <Text fz={big ? 30 : 22} fw={700} mt={4} lh={1.2}>
      {formatCurrency(value, currency)}
    </Text>
    {hint && (
      <Text size="xs" c="dimmed">
        {hint}
      </Text>
    )}
    <ChangeIndicator value={value} previousValue={previousValue} label="vs previous period" />
    {footer}
  </Paper>
);

export default MetricTile;
